import React, { FC } from 'react'
import useDeviceSize from 'src/hooks/useDeviceSize'
import Link from 'next/link'
import { Button } from 'src/components/Common/Button'
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io'
import { useDispatch, useSelector } from 'react-redux'
import { State } from 'src/store/rootReducers'
import { setClass } from 'src/store/general'
import { TfiMenu } from 'react-icons/tfi'
import ProfileHeader from 'src/components/Common/ProfileHeader'
import { useRouter } from 'next/router'
import { Lesson } from 'src/service/api/api.types'
import {AiTwotoneHome} from "react-icons/ai";
import { Content, Grid, LogoDesktop, MenuHeader } from './styles'

const MenuPrivate: FC = () => {
  const router = useRouter()
  const stateMenu = useSelector((state: State) => state.general.classMenu)
  const module = useSelector((state: State) => state.course.module)
  const [width] = useDeviceSize()
  const dispatch = useDispatch()

  const isMobile = width <= 768
  const mustShow = !isMobile || stateMenu
  const handleHamburger = () => dispatch(setClass())

  React.useEffect(() => {
    if (stateMenu) {
      document.body.classList.add('stop-scrolling')
    }
    return () => document.body.classList.remove('stop-scrolling')
  }, [stateMenu])

  async function changePage(lesson?: Lesson) {
    if (lesson) {
      await router.push(`/curso/aula/${lesson.slug}`)
    }
  }

  return (
    <MenuHeader>
      <Content className={mustShow ? 'mobile' : ''}>
        <Grid>
          <div className="logo">
            <Link legacyBehavior passHref href="/">
              <a>
                <LogoDesktop
                  src="https://res.cloudinary.com/cordasemusica/image/upload/f_webp/v1678224794/logo-static_rkjkve.png"
                  alt="Logo Cordas e Música Projeto Musical"
                />
              </a>
            </Link>
          </div>

          <div className="button_home">
            <Button
              type="button"
              isLink
              href="/"
              labelTx="header.backHome"
              preset="secondary"
              LeftAccessory={<AiTwotoneHome />}
            />
          </div>

          <div className="backdrop" onClick={handleHamburger} />

          {isMobile ? (
            <div className="button-hamburger" onClick={handleHamburger}>
              <TfiMenu />
            </div>
          ) : null}

          <div className="button-actions">
            <Button
              type="button"
              labelTx="classes.actions.previous"
              preset="actionL"
              onClick={() => changePage(module?.pagination.previous)}
              disabled={!module?.pagination.previous}
              hasIconAndText
              LeftAccessory={<IoIosArrowBack />}
            />

            <Button
              type="button"
              labelTx="classes.actions.next"
              preset="actionR"
              onClick={() => changePage(module?.pagination.next)}
              disabled={!module?.pagination.next}
              hasIconAndText
              RightAccessory={<IoIosArrowForward />}
            />
          </div>

          <ProfileHeader visibleNameMobile={isMobile} />
        </Grid>
      </Content>
    </MenuHeader>
  )
}
export default MenuPrivate
